


















































import { Component, Vue } from 'vue-property-decorator';

declare const daum: any;

@Component({})
export default class Sixth extends Vue {
  private baseUrl = process.env.BASE_URL;
  private sessionList = [
    {
      title: 'Vue.js를 이용한 백오피스 구현기',
      desc: '관리자, 물류, 점포 등의 페이지를 구현하면서 생각한 컴포넌트 재사용성 이슈와 조금의 백앤드 이야기',
      author: '마광휘, 와인포인트',
      thumbUrl: `${this.baseUrl}static/sixth/img/presenters/author01.jpeg`
    },
    {
      id: 2,
      title: 'Nuxt.js vs Next.js',
      desc: '현존하는 핫한 두 View 라이브러리인 vue.js와 react.js의 편의성을 위해 Framework가 만들어졌습니다. 그것들을에 대한 내용과 장,단점에 대해 이야기해보겠습니다.',
      author: '임석민',
      thumbUrl: `${this.baseUrl}static/sixth/img/presenters/author02.jpeg`
    },
    {
      id: 3,
      title: 'Deep dive into Vue.js',
      desc:
        '사용법만 알았던 Vue.js, 이번 기회에 Vue.js가 어떻게 만들어졌는지 어떠한 원리로 동작하는지 깊게 알아봅시다.',
      author: '이선협, Cobalt. Inc',
      thumbUrl: `${this.baseUrl}static/sixth/img/presenters/author03.jpeg`
    }
  ];

  private mounted() {
    // console.log(process.env.BASE_URL);
    const map = new daum.maps.Map(this.$refs.map, {
      center: new daum.maps.LatLng(37.497145, 127.028567),
      level: 3
    });

    const marker = new daum.maps.Marker({
      position: new daum.maps.LatLng(37.497145, 127.028567),
      image: new daum.maps.MarkerImage(`${this.baseUrl}logo.png`, new daum.maps.Size(50, 50), {
        offset: new daum.maps.Point(20, 40)
      })
    }).setMap(map);

    new daum.maps.InfoWindow({
      position: new daum.maps.LatLng(37.4975, 127.02863),
      content: `<div style="padding:5px;background-color: #62BC7F;color: #3C475E;font-weight:
        bold;width: 150px;">Hello Vuers!!</div>`
    }).open(map, marker);
  }
}
